var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2044 16.8128L25.9641 18.0532L23.4834 15.5725L24.7237 14.3321C24.8478 14.2081 24.9718 14.0841 25.2199 14.0841C25.3439 14.0841 25.592 14.2081 25.716 14.3321L27.3285 15.9446C27.4525 16.1927 27.4525 16.5648 27.2044 16.8128ZM15.173 23.7588V26.3635H17.7778L25.3439 18.7974L22.8632 16.3167L15.173 23.7588ZM25.0958 5.27758C25.0958 3.91319 23.9795 2.79688 22.6151 2.79688H5.25023C3.88585 2.79688 2.76953 3.91319 2.76953 5.27758V22.6425C2.76953 24.0069 3.88585 25.1232 5.25023 25.1232H12.6923V22.7665L14.0567 21.4021H5.25023L9.59146 15.8206L12.6923 19.5416L17.0336 13.96L19.0181 16.5648L25.0958 10.363V5.27758Z",
    fill: "#0FAF71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditImage);
export default __webpack_public_path__ + "static/media/editImage.a30bc0f6f5c038cb45722deac4e94417.svg";
export { ForwardRef as ReactComponent };